/* @flow */

import * as React from "react";
import { IntlProvider, intlShape } from "react-intl";
import { getFormats, getLang, getMessages } from "./i18n/i18nDataBuilder";

const intlProps = {
    locale: getLang(),
    messages: getMessages(), //for this ui, the messages are already flattened
    formats: getFormats()
};
const intlProvider = new IntlProvider(intlProps, {});

export const IntlRootMixin = {
    contextTypes: {
        intl: intlShape.isRequired
    },
    childContextTypes: {
        intl: intlShape.isRequired
    },
    getDefaultProps() {
        return intlProvider.getChildContext();
    },
    getChildContext() {
        return intlProvider.getChildContext();
    }
};

function getDisplayName(Component: React.ComponentType<any>): string {
    return Component.displayName || (typeof Component === "function" ? Component.name : "");
}

export function wrappedDisplayName(wrapperName: string, Component: React.ComponentType<any>): string {
    return wrapperName + "(" + getDisplayName(Component) + ")";
}

export function withIntlRoot<T extends {}>(
    WrappedComponent: React.ComponentType<T>
): React.ComponentType<
    Pick<
        T,
        Exclude<
            keyof T,
            keyof {
                intl: any;
            }
        >
    >
> {
    class Wrapper extends React.Component<T> {
        constructor(props: T) {
            super(props);
        }
        static getDefaultProps() {
            return intlProvider.getChildContext();
        }
        getChildContext() {
            return intlProvider.getChildContext();
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
        static contextTypes = {
            intl: intlShape.isRequired
        };
        static childContextTypes = {
            intl: intlShape.isRequired
        };
        static displayName = wrappedDisplayName("withIntlRoot", WrappedComponent);
    }
    return Wrapper as any;
}

export function jsxWithIntl(content: any): React.ReactNode {
    return <IntlProvider {...intlProps}>{content}</IntlProvider>;
}
